// extracted by mini-css-extract-plugin
export default {"contactContainer":"Kontakt_contactContainer__MRzJO","sentMessage":"Kontakt_sentMessage__0Wmpq","greenTextField":"Kontakt_greenTextField__031Df"};